var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-2" }, [
        _c("h3", [_vm._v("Core Details")]),
      ]),
      _c("base-form", {
        ref: "coreFormRef",
        on: { submit: _vm.saveCore },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Core Title",
                            value: _vm.coreForm.title,
                            rules: "required",
                            placeholder: "Enter core title",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.coreForm, "title", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-select", {
                          attrs: {
                            label: "Core Type",
                            value: _vm.coreForm.coreType,
                            items: _vm.coreTypes,
                            placeholder: "Select core type",
                            clearable: "",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.coreForm, "coreType", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-select", {
                          attrs: {
                            label: "Core Function",
                            value: _vm.coreForm.coreFunction,
                            items: _vm.coreFunctions,
                            placeholder: "Select core function",
                            clearable: "",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.coreForm,
                                "coreFunction",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Core Material",
                            value: _vm.coreForm.coreMaterial,
                            placeholder: "Enter core material",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.coreForm,
                                "coreMaterial",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Rated Current (A)",
                            value: _vm.coreForm.coreRatedCurrent,
                            type: "number",
                            placeholder: "Enter rated current in amperes",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.coreForm,
                                "coreRatedCurrent",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Cross Section (mm²)",
                            value: _vm.coreForm.coreCrossSection,
                            type: "number",
                            placeholder: "Enter cross section in mm²",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.coreForm,
                                "coreCrossSection",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: {
                              row: "",
                              label: "Intrinsic Safety",
                              disabled: _vm.readonly,
                            },
                            model: {
                              value: _vm.coreForm.coreIntrinsicSafety,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.coreForm,
                                  "coreIntrinsicSafety",
                                  $$v
                                )
                              },
                              expression: "coreForm.coreIntrinsicSafety",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "Yes",
                                value: true,
                              },
                            }),
                            _c("v-radio", {
                              attrs: {
                                color: "#1b3054",
                                label: "No",
                                value: false,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Connected From Equipment Pin",
                            value:
                              _vm.selectedCore?.equipmentInPin?.title ||
                              "Not connected",
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Connected To Equipment Pin",
                            value:
                              _vm.selectedCore?.equipmentOutPin?.title ||
                              "Not connected",
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Associated Cable",
                            value: _vm.selectedCore?.cableId
                              ? _vm.getCableTitle(_vm.selectedCore.cableId)
                              : "No cable (standalone core)",
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.readonly
                  ? _c(
                      "v-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  color: "grey",
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v("Reset")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  type: "submit",
                                  loading: _vm.isLoading,
                                  disabled: invalid,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEditing
                                        ? "Update Core"
                                        : "Create Core"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }